import type { SessionState } from '../session/Session';
import type { TableModel } from '../model/table';
import { GameSettings } from '../display/GameDisplay';

const CONNECTION_TEXT: Record<SessionState['connection'], string> = {
  connecting: 'Connecting', open: 'Connected', reconnecting: 'Reconnecting', closed: 'Disconnected',
};

export function TopBar({ state, table }: { state: SessionState; table: TableModel }) {
  const seatLabel = table.selfSeat ? table.seats.find(s => s.isSelf)?.label ?? table.selfSeat : 'Spectator';
  return (
    <header className="topbar">
      <div className="topbar-title">
        <div className="game-title-line"><h1>{state.title ?? table.title}</h1><GameSettings /></div>
        <p className="topbar-status" aria-live="polite">{table.status}</p>
      </div>
      <div className="topbar-meta">
        <span className="badge">{seatLabel}</span>
        <span className={`connection connection-${state.connection}`} role="status">
          <span className="connection-dot" aria-hidden="true" />{CONNECTION_TEXT[state.connection]}
        </span>
      </div>
    </header>
  );
}
